import { Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react';
import {
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverFooter,
  PopoverHeader,
  PopoverTrigger,
} from '@chakra-ui/react';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import {
  TimeHourglassIcon,
  WhiteBoardAttachmentIcon,
  WhiteboardImageIcon,
  WhiteBoardStampIcon,
} from '@sketchnote/icons';
import { Button, Panel as Panel2, Tabs } from '@sketchnote/shared-components';
import * as React from 'react';
import { borderRadius } from 'react-select/src/theme';
import { Panel, TDShapeType, ToolButton, Tooltip, useTldrawApp } from 'sn-wb-tldraw';

import { FileUpload } from './FileUpload';
import { ImageUpload } from './ImageUpload';
import { LessonUpload } from './LessonUpload';
import { LinkUpload } from './LinkUpload';

export const AttachmentMenu = React.memo(function StampMenu(): JSX.Element {
  const app = useTldrawApp();
  const isSmallScreen = window.innerHeight < 800;
  const offset = isSmallScreen ? -266 : -370;
  const sideOffset = isSmallScreen ? 27 : 36;

  React.useEffect(() => {
    //removing overflow hidden or else submenu keeps getting cut off
    const attachmentMenus = document.getElementById('attachment-menu')?.querySelectorAll('.css-0');
    attachmentMenus?.forEach((menu) => menu.classList.remove('css-0'));
  }, []);
  return (
    <div id="attachment-menu">
      <Menu direction="ltr" isLazy offset={[offset, sideOffset]} placement="right">
        <div style={{ overflow: 'visible !important' }}>
          <div
            onClick={() => {
              app.selectSticker('');
              app.selectTool('select');
            }}
            className="h-48 w-48  smallScreen:h-32 smallScreen:w-32 flex justify-center items-center"
          >
            <Tooltip id="Attachments" label="Attachments" side="right">
              <MenuButton className="bg-gray-100 rounded-sm h-48 w-48 smallScreen:h-32 smallScreen:w-32 flex items-center justify-center">
                <WhiteBoardAttachmentIcon
                  fill={'#55585E'}
                  wrapperClass="transform smallScreen:scale-50"
                />
              </MenuButton>
            </Tooltip>
          </div>

          <MenuList>
            <div
              className="py-5 smallScreen:py-2 w-57 smallScreen:w-37 bg-white "
              style={{
                boxShadow: '0px 4px 4px rgba(135, 138, 146, 0.15)',
                borderRadius: `${isSmallScreen ? '9px' : '14px'}`,
                border: '1px solid #E2E4E9',
              }}
            >
              <div className="flex flex-col gap-8 items-center py-6 smallScreen:py-3">
                <ImageUpload />

                <LinkUpload />

                <FileUpload />

                {/* <LessonUpload /> */}

                <div onClick={() => app.setTimer(true)}>
                  <MenuItem
                    className="h-36 w-36 smallScreen:w-23 smallScreen:h-23 flex justify-center items-center cursor-pointer"
                    style={{
                      border: '0.79px solid #E2E4E9',
                      borderRadius: '3.17241px',
                    }}
                  >
                    <TimeHourglassIcon
                      fill={'#55585E'}
                      wrapperClass={'transform smallScreen:scale-60'}
                    />
                  </MenuItem>
                  <p
                    style={{
                      fontSize: `${isSmallScreen ? '8px' : '12.48px'}`,
                      textAlign: 'center',
                      lineHeight: `${isSmallScreen ? '16px' : '24.96px'}`,
                    }}
                  >
                    Timer
                  </p>
                </div>
              </div>
            </div>
          </MenuList>
        </div>
      </Menu>
    </div>
  );
});
